<template>
  <div class="dynamic" v-html="text">
  </div>
</template>
<script>
export default {
  name: "DDynamicText",
  props: {
    dynamic: {
      Type: Array,
      required: true,
      default: () => []
    },
    parentMetas: {
      type: Object,
      required: false,
      default: () => { }
    }
  },
  computed: {
    text: {
      get() {
        let text = '';
        if (this.dynamic.validation.metas) {
          text = this.filterValuesByMetas(this.dynamic)
        }
        if (!text) {
          this.$emit("show", false)
          return;
        }
        this.$emit("show", true)
        return text;
      }
    }
  },
  methods: {
    filterValuesByMetas(dynamic) {
      if (!this.parentMetas) {
        return '';
      }
      const metaName = dynamic.validation.metas.meta ?? "parentId";
      if (!this.parentMetas[metaName]) {
        return '';
      }
      const match = dynamic.items.find(i => {
        switch (dynamic.validation.metas.logic) {
          case "!=":
            return i.ref.toLowerCase() !== this.parentMetas[metaName].toLowerCase();
          case ">":
            return i.ref.toLowerCase() > this.parentMetas[metaName].toLowerCase();
          case ">=":
            return i.ref.toLowerCase() >= this.parentMetas[metaName].toLowerCase();
          case "<":
            return i.ref.toLowerCase() < this.parentMetas[metaName].toLowerCase();
          case "<=":
            return i.ref.toLowerCase() <= this.parentMetas[metaName].toLowerCase();
          case "includes":
            if (this.parentMetas[metaName] instanceof Array) {
              return this.parentMetas[metaName].map(t => t.toLowerCase()).includes(i.ref.toLowerCase())
            }
            return this.parentMetas[metaName].toLowerCase().includes(i.ref.toLowerCase())
          default:
            return i.ref.toLowerCase() === this.parentMetas[metaName].toLowerCase();
        }
      })
      return match?.value ?? ""
    },
  }
}
</script>
<style lang="scss" scoped>
.dynamic {
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>